/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getShiftSchedules} from '../api'

 export const useQueryGetShiftSchedules = createReactQueryHook('getShiftSchedules', getShiftSchedules)
